(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abe-service-form"] && !Shopify.designMode) return;
  try {
    
  class AbeServiceForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.abeForm = this.querySelector('[data-abe-cart-form]');
      this.errorBox = this.querySelector('[data-abe-error]');
      this.requiredControls = Array.from(this.querySelectorAll('[required]'));
      this.birthdateInput = this.querySelector('[data-abe-birthdate]');
      this.submitButton = this.querySelector('[data-abe-submit]');
      this.variantInput = this.querySelector('[data-abe-variant-id]');

      this.setupModelCombobox();

      this.querySelectorAll('[data-abe-file]').forEach((input) => {
        const label = input.closest('.abe-service-form__upload')?.querySelector('[data-abe-file-label]');
        if (label) label.dataset.defaultText = label.textContent;
        input.addEventListener('change', () => this.updateFileLabel(input));
      });

      document.addEventListener(
        'click',
        (event) => {
          const scrollTrigger = event.target.closest('[data-abe-scroll-trigger]');
          if (!scrollTrigger) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (!this.validate()) return;
          this.scrollToFormActions();
        },
        true
      );

      if (this.abeForm) {
        this.abeForm.addEventListener('submit', (event) => {
          if (this.submitButton?.getAttribute('aria-disabled') === 'true') {
            event.preventDefault();
            return;
          }

          if (!this.validate() || !this.syncCartFields()) {
            event.preventDefault();
            return;
          }

          this.setSubmitting(true);
        });
      }
    }

    setupModelCombobox() {
      this.modelSelectRoot = this.querySelector('[data-abe-model-select-root]');
      this.modelSelect = this.querySelector('[data-abe-model-select]');
      this.modelCombobox = this.querySelector('[data-abe-model-combobox]');
      this.modelSearch = this.querySelector('[data-abe-model-search]');
      this.modelToggle = this.querySelector('[data-abe-model-toggle]');
      this.modelPanel = this.querySelector('[data-abe-model-panel]');
      this.modelList = this.querySelector('[data-abe-model-list]');
      this.modelEmpty = this.querySelector('[data-abe-model-empty]');

      if (
        !this.modelSelectRoot ||
        !this.modelSelect ||
        !this.modelCombobox ||
        !this.modelSearch ||
        !this.modelPanel ||
        !this.modelList ||
        !this.modelEmpty
      ) {
        return;
      }

      const sourceOptions = Array.from(this.modelSelect.options).filter((option) => option.value);
      const fragment = document.createDocumentFragment();

      this.modelOptionItems = sourceOptions.map((option, index) => {
        const item = document.createElement('div');
        item.id = `${this.modelList.id}-option-${index}`;
        item.className = 'abe-service-form__combobox-option';
        item.dataset.value = option.value;
        item.dataset.searchValue = this.normalizeModelValue(`${option.textContent} ${option.value}`);
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.textContent = option.textContent.trim();
        item.addEventListener('pointerdown', (event) => event.preventDefault());
        item.addEventListener('click', () => this.selectModelOption(item));
        fragment.appendChild(item);
        return item;
      });

      this.modelList.appendChild(fragment);
      this.visibleModelOptions = this.modelOptionItems.slice();
      this.activeModelIndex = -1;
      this.modelSelectRoot.classList.add('is-enhanced');
      this.modelSelect.tabIndex = -1;
      this.modelSelect.setAttribute('aria-hidden', 'true');
      this.modelCombobox.hidden = false;
      this.syncModelSelection();

      this.modelSearch.addEventListener('focus', () => {
        this.openModelCombobox();
        if (this.modelSelect.value) requestAnimationFrame(() => this.modelSearch.select());
      });
      this.modelSearch.addEventListener('click', () => this.openModelCombobox());
      this.modelSearch.addEventListener('input', () => {
        const selectedOption = this.modelSelect.selectedOptions[0];
        if (
          this.modelSelect.value &&
          selectedOption &&
          this.modelSearch.value !== selectedOption.textContent.trim()
        ) {
          this.modelSelect.value = '';
          this.modelOptionItems.forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-selected', 'false');
          });
        }
        this.openModelCombobox();
        this.filterModelOptions(this.modelSearch.value, true);
      });
      this.modelSearch.addEventListener('keydown', (event) => this.handleModelKeydown(event));
      this.modelToggle?.addEventListener('pointerdown', (event) => event.preventDefault());
      this.modelToggle?.addEventListener('click', () => {
        if (this.modelPanel.hidden) {
          this.modelSearch.focus();
        } else {
          this.closeModelCombobox(true);
          this.modelSearch.focus();
        }
      });
      this.modelSelect.addEventListener('change', () => this.syncModelSelection());
      this.querySelector(`#${CSS.escape(this.modelSearch.getAttribute('aria-labelledby'))}`)?.addEventListener('click', (event) => {
        event.preventDefault();
        this.modelSearch.focus();
      });
      document.addEventListener('pointerdown', (event) => {
        if (!this.modelCombobox.contains(event.target)) this.closeModelCombobox(true);
      });
    }

    normalizeModelValue(value) {
      return value.normalize('NFKD').toLocaleLowerCase().replace(/[\s_-]+/g, '');
    }

    openModelCombobox() {
      if (!this.modelPanel?.hidden) return;
      this.modelPanel.hidden = false;
      this.modelCombobox.classList.add('is-open');
      this.modelSearch.setAttribute('aria-expanded', 'true');
      this.filterModelOptions(this.modelSelect.value ? '' : this.modelSearch.value, false);
    }

    closeModelCombobox(restoreValue = false) {
      if (!this.modelPanel || this.modelPanel.hidden) return;
      if (restoreValue) this.syncModelSelection();
      this.modelPanel.hidden = true;
      this.modelCombobox.classList.remove('is-open');
      this.modelSearch.setAttribute('aria-expanded', 'false');
      this.setActiveModelOption(-1);
    }

    filterModelOptions(query, activateFirst) {
      const normalizedQuery = this.normalizeModelValue(query);
      this.visibleModelOptions = this.modelOptionItems.filter((item) => {
        const matches = !normalizedQuery || item.dataset.searchValue.includes(normalizedQuery);
        item.hidden = !matches;
        return matches;
      });
      this.modelEmpty.hidden = this.visibleModelOptions.length > 0;
      this.setActiveModelOption(activateFirst && this.visibleModelOptions.length ? 0 : -1);
    }

    setActiveModelOption(index) {
      this.modelOptionItems.forEach((item) => item.classList.remove('is-active'));
      this.activeModelIndex = index;

      const activeItem = this.visibleModelOptions[index];
      if (!activeItem) {
        this.modelSearch.removeAttribute('aria-activedescendant');
        return;
      }

      activeItem.classList.add('is-active');
      this.modelSearch.setAttribute('aria-activedescendant', activeItem.id);
      activeItem.scrollIntoView({ block: 'nearest' });
    }

    selectModelOption(item) {
      this.modelSelect.value = item.dataset.value;
      this.syncModelSelection();
      this.modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
      this.closeModelCombobox(false);
      this.modelSearch.focus();
    }

    syncModelSelection() {
      if (!this.modelSelect || !this.modelSearch) return;
      const selectedOption = this.modelSelect.selectedOptions[0];
      this.modelSearch.value = this.modelSelect.value && selectedOption ? selectedOption.textContent.trim() : '';
      this.modelOptionItems?.forEach((item) => {
        const isSelected = Boolean(this.modelSelect.value) && item.dataset.value === this.modelSelect.value;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', String(isSelected));
      });

      if (this.modelSelect.value) {
        this.modelSelect.classList.remove('is-invalid');
        this.modelSelect.removeAttribute('aria-invalid');
        this.modelCombobox.classList.remove('is-invalid');
        this.modelSearch.removeAttribute('aria-invalid');
      }
    }

    handleModelKeydown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.openModelCombobox();
        if (!this.visibleModelOptions.length) return;
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = this.activeModelIndex < 0
          ? (direction > 0 ? 0 : this.visibleModelOptions.length - 1)
          : (this.activeModelIndex + direction + this.visibleModelOptions.length) % this.visibleModelOptions.length;
        this.setActiveModelOption(nextIndex);
        return;
      }

      if (event.key === 'Enter' && !this.modelPanel.hidden) {
        const activeItem = this.visibleModelOptions[this.activeModelIndex];
        if (activeItem) {
          event.preventDefault();
          this.selectModelOption(activeItem);
        }
        return;
      }

      if (event.key === 'Escape' && !this.modelPanel.hidden) {
        event.preventDefault();
        this.closeModelCombobox(true);
        return;
      }

      if (event.key === 'Tab') this.closeModelCombobox(true);
    }

    updateFileLabel(input) {
      const label = input.closest('.abe-service-form__upload')?.querySelector('[data-abe-file-label]');
      if (!label) return;
      label.textContent = input.files && input.files.length ? input.files[0].name : label.dataset.defaultText;
    }

    scrollToFormActions() {
      const target = this.querySelector('.abe-service-form__actions') || this;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.querySelector('.abe-service-form__submit')?.focus({ preventScroll: true });
    }

    syncCartFields() {
      const variantId = this.variantInput?.value;
      if (!variantId) {
        this.showError();
        return false;
      }

      return true;
    }


    setSubmitting(isSubmitting) {
      if (!this.submitButton) return;
      this.submitButton.toggleAttribute('aria-disabled', isSubmitting);
      this.submitButton.classList.toggle('loading', isSubmitting);
      this.submitButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !isSubmitting);
    }

    validate() {
      let firstInvalid = null;
      this.hideError();

      this.requiredControls.forEach((control) => {
        control.classList.remove('is-invalid');
        control.removeAttribute('aria-invalid');
        if (control === this.modelSelect) {
          this.modelCombobox?.classList.remove('is-invalid');
          this.modelSearch?.removeAttribute('aria-invalid');
        }

        if (!control.checkValidity()) {
          firstInvalid = firstInvalid || control;
          this.markInvalid(control);
        }
      });

      if (this.birthdateInput && !this.isAdultBirthdate(this.birthdateInput.value)) {
        firstInvalid = firstInvalid || this.birthdateInput;
        this.markInvalid(this.birthdateInput);
      }

      if (firstInvalid) {
        this.showError();
        this.focusInvalidControl(firstInvalid);
        return false;
      }

      return true;
    }

    markInvalid(control) {
      control.classList.add('is-invalid');
      control.setAttribute('aria-invalid', 'true');
      if (control === this.modelSelect) {
        this.modelCombobox?.classList.add('is-invalid');
        this.modelSearch?.setAttribute('aria-invalid', 'true');
      }
    }

    focusInvalidControl(control) {
      const focusTarget = control === this.modelSelect ? this.modelSearch : control;
      if (control === this.modelSelect) this.openModelCombobox();
      focusTarget?.focus({ preventScroll: true });
      focusTarget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    showError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = false;
      this.errorBox.focus({ preventScroll: true });
    }

    hideError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = true;
    }

    isAdultBirthdate(value) {
      const match = value.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (!match) return false;

      const day = Number(match[1]);
      const month = Number(match[2]);
      const year = Number(match[3]);
      const birthdate = new Date(year, month - 1, day);

      if (
        birthdate.getFullYear() !== year ||
        birthdate.getMonth() !== month - 1 ||
        birthdate.getDate() !== day
      ) {
        return false;
      }

      const today = new Date();
      const minimum = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      return birthdate <= minimum;
    }
  }

  if (!customElements.get('abe-service-form')) {
    customElements.define('abe-service-form', AbeServiceForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefillInquiry = () => {
      const body = document.getElementById('ContactForm-body');
      if (!body || body.value.trim()) return;
      const params = new URLSearchParams(window.location.search);
      const messages = {
        Finanzierung: body.dataset.inquiryFinance,
        Ersatzteile: body.dataset.inquiryParts,
        Modelle: body.dataset.inquiryModels
      };
      const topic = params.get('anliegen');
      if (!Object.hasOwn(messages, topic) || !messages[topic]) return;
      const brand = (params.get('marke') || '').slice(0, 80);
      const part = (params.get('teil') || '').slice(0, 80);
      body.value = messages[topic].replaceAll('{brand}', brand).replaceAll('{part}', part);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', prefillInquiry, { once: true });
    } else {
      prefillInquiry();
    }
    document.addEventListener('shopify:section:load', prefillInquiry);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      if (this.closeSearchModal) {
        this.closeSearchModal();
      }
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-support-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('support-faq')) {
    customElements.define('support-faq', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-faq-search]');
        this.clearButton = this.querySelector('[data-faq-clear]');
        this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
        this.filters = Array.from(this.querySelectorAll('[data-category]'));
        this.empty = this.querySelector('[data-faq-empty]');
        this.count = this.querySelector('[data-faq-result-count]');
        this.activeCategory = 'all';
        this.querySelector('[data-faq-search-form]')?.addEventListener('submit', event => event.preventDefault());
        this.input?.addEventListener('input', () => this.filter());
        this.clearButton?.addEventListener('click', () => this.resetSearch());
        this.querySelector('[data-faq-reset]')?.addEventListener('click', () => this.resetAll());
        this.filters.forEach(button => button.addEventListener('click', () => this.selectCategory(button)));
      }
      normalize(value) {
        return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      }
      selectCategory(button) {
        this.activeCategory = button.dataset.category;
        this.filters.forEach(filter => {
          const active = filter === button;
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.filter();
      }
      filter() {
        const term = this.normalize(this.input?.value || '');
        let visible = 0;
        this.items.forEach(item => {
          const matchesCategory = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
          const matchesTerm = !term || this.normalize(item.dataset.searchText || '').includes(term);
          const show = matchesCategory && matchesTerm;
          item.hidden = !show;
          if (show) visible += 1;
        });
        if (this.clearButton) this.clearButton.hidden = !term;
        if (this.empty) this.empty.hidden = visible !== 0;
        if (this.count) {
          const template = this.count.dataset.resultTemplate || '[count]';
          this.count.textContent = template.replace('[count]', visible);
        }
      }
      resetSearch() {
        if (this.input) {
          this.input.value = '';
          this.input.focus();
        }
        this.filter();
      }
      resetAll() {
        if (this.input) this.input.value = '';
        const allButton = this.filters.find(button => button.dataset.category === 'all');
        if (allButton) this.selectCategory(allButton);
        this.input?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weroll-home-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weroll-benefits-carousel')) {
    customElements.define('weroll-benefits-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.wr-benefits__track');
        this.cards = Array.from(this.querySelectorAll('[data-benefit-card]'));
        if (!this.track || !this.cards.length) return;

        this.activeIndex = Math.min(Math.max(Number(this.dataset.initialCard) || 0, 0), this.cards.length - 1);
        this.drag = { active: false, moved: false, startX: 0, startScroll: 0 };
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cards.forEach((card, index) => {
          card.addEventListener('pointerenter', event => {
            if (event.pointerType !== 'touch') this.activate(index, false);
          });
          card.addEventListener('focus', () => this.activate(index, false));
          card.addEventListener('click', () => {
            if (this.drag.moved) return;
            this.activate(index, true);
          });
          card.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.activate(index, true);
            }
          });
        });

        this.querySelector('[data-benefit-previous]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-benefit-next]')?.addEventListener('click', () => this.step(1));
        this.track.addEventListener('pointerdown', event => this.startDrag(event));
        this.track.addEventListener('pointermove', event => this.moveDrag(event));
        this.track.addEventListener('pointerup', event => this.endDrag(event));
        this.track.addEventListener('pointercancel', event => this.endDrag(event));
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') this.step(-1);
          if (event.key === 'ArrowRight') this.step(1);
        });

        this.activate(this.activeIndex, false);
        requestAnimationFrame(() => this.scrollToCard(this.activeIndex, false));
      }

      activate(index, shouldScroll) {
        this.activeIndex = Math.min(Math.max(index, 0), this.cards.length - 1);
        this.cards.forEach((card, cardIndex) => {
          const isActive = cardIndex === this.activeIndex;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-current', isActive ? 'true' : 'false');
          card.querySelector('.wr-benefits__details')?.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        if (shouldScroll) this.scrollToCard(this.activeIndex, true);
      }

      step(direction) {
        this.activate((this.activeIndex + direction + this.cards.length) % this.cards.length, true);
      }

      scrollToCard(index, animate) {
        const card = this.cards[index];
        const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: animate && !this.reduceMotion ? 'smooth' : 'auto' });
      }

      startDrag(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.drag = { active: true, moved: false, startX: event.clientX, startScroll: this.track.scrollLeft };
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      }

      moveDrag(event) {
        if (!this.drag.active) return;
        const distance = event.clientX - this.drag.startX;
        if (Math.abs(distance) > 5) this.drag.moved = true;
        this.track.scrollLeft = this.drag.startScroll - distance;
      }

      endDrag(event) {
        if (!this.drag.active) return;
        this.drag.active = false;
        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        const nearest = this.cards.reduce((best, card, index) => Math.abs(card.offsetLeft + card.offsetWidth / 2 - center) < best.distance ? { index, distance: Math.abs(card.offsetLeft + card.offsetWidth / 2 - center) } : best, { index: 0, distance: Infinity });
        this.activate(nearest.index, true);
        setTimeout(() => { this.drag.moved = false; }, 0);
      }

    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weroll-home-brands"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wr-brand-filter')) {
    customElements.define('wr-brand-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-brand-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-brand-panel]'));
        this.productTracks = Array.from(this.querySelectorAll('[data-brand-product-track]'));
        this.scrollTrack = this.querySelector('[data-brand-scroll-track]');
        this.brandTabs = this.querySelector('[data-brand-scroll-track] [role="tablist"]');
        this.allBrandsLink = this.scrollTrack?.querySelector('.wr-home__brand--all');
        this.scrollNext = this.querySelector('[data-brand-scroll-next]');
        this.updateSidebarHeight = () => {
          if (!window.matchMedia('(min-width: 990px)').matches) {
            this.style.removeProperty('--wr-brand-sidebar-height');
            return;
          }
          const activePanel = this.panels.find((panel) => !panel.hidden);
          const content = activePanel?.querySelector('[data-brand-product-viewport], .wr-home__brand-empty');
          const height = content?.getBoundingClientRect().height || 0;
          const tabsHeight = this.brandTabs?.scrollHeight || 0;
          const allBrandsHeight = this.allBrandsLink?.getBoundingClientRect().height || 0;
          const gap = this.scrollTrack ? parseFloat(getComputedStyle(this.scrollTrack).rowGap || getComputedStyle(this.scrollTrack).gap) || 0 : 0;
          const minimumHeight = tabsHeight + allBrandsHeight + gap;
          const sidebarHeight = Math.max(height, minimumHeight);
          if (sidebarHeight > 0) this.style.setProperty('--wr-brand-sidebar-height', `${Math.ceil(sidebarHeight)}px`);
        };
        this.updateScrollButton = () => {
          if (!this.scrollTrack || !this.scrollNext) return;
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const hasOverflow = this.scrollTrack.scrollWidth > this.scrollTrack.clientWidth + 2;
          const isAtEnd = this.scrollTrack.scrollLeft + this.scrollTrack.clientWidth >= this.scrollTrack.scrollWidth - 2;
          this.scrollNext.hidden = !isMobile || !hasOverflow || isAtEnd;
        };
        if (this.scrollTrack && this.scrollNext) {
          this.scrollNext.addEventListener('click', () => {
            const card = this.scrollTrack.querySelector('.wr-home__brand');
            const gap = parseFloat(getComputedStyle(this.scrollTrack).columnGap) || 0;
            const distance = card ? card.getBoundingClientRect().width + gap : this.scrollTrack.clientWidth * 0.82;
            const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
            this.scrollTrack.scrollBy({ left: distance, behavior });
          });
          this.scrollTrack.addEventListener('scroll', this.updateScrollButton, { passive: true });
          this.scrollResizeObserver = new ResizeObserver(this.updateScrollButton);
          this.scrollResizeObserver.observe(this.scrollTrack);
          requestAnimationFrame(this.updateScrollButton);
        }
        this.productTracks.forEach((track) => this.setupProductTrack(track));
        requestAnimationFrame(this.updateSidebarHeight);
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-brand-tab]');
          if (tab && this.contains(tab)) this.selectTab(tab);
        });
        this.addEventListener('keydown', (event) => {
          const currentIndex = this.tabs.indexOf(event.target);
          if (currentIndex < 0) return;
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex !== currentIndex) {
            event.preventDefault();
            this.selectTab(this.tabs[nextIndex]);
            this.tabs[nextIndex].focus();
          }
        });
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[data-brand-tab]');
          if (tab) this.selectTab(tab);
        });
      }
      setupProductTrack(track) {
        const viewport = track.closest('[data-brand-product-viewport]');
        const previous = viewport?.querySelector('[data-product-scroll-previous]');
        const next = viewport?.querySelector('[data-product-scroll-next]');
        const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const scrollDistance = () => {
          const card = track.querySelector('.wr-home__brand-product');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        };
        const updateArrows = () => {
          if (!previous || !next) return;
          const desktop = window.matchMedia('(min-width: 990px)').matches;
          const overflow = track.scrollWidth > track.clientWidth + 2;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          previous.hidden = !desktop || !overflow || track.scrollLeft <= 2;
          next.hidden = !desktop || !overflow || atEnd;
          viewport?.classList.toggle('is-at-end', !overflow || atEnd);
        };
        previous?.addEventListener('click', () => {
          track.scrollBy({ left: -scrollDistance(), behavior: reducedMotion() ? 'auto' : 'smooth' });
        });
        next?.addEventListener('click', () => {
          track.scrollBy({ left: scrollDistance(), behavior: reducedMotion() ? 'auto' : 'smooth' });
        });
        let dragStartX = 0;
        let dragStartScroll = 0;
        let dragMoved = false;
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !window.matchMedia('(min-width: 990px)').matches) return;
          dragMoved = false;
          dragStartX = event.clientX;
          dragStartScroll = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });
        track.addEventListener('pointermove', (event) => {
          if (!track.classList.contains('is-dragging')) return;
          if (Math.abs(event.clientX - dragStartX) > 4) dragMoved = true;
          track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
        });
        const stopDragging = (event) => {
          if (!track.classList.contains('is-dragging')) return;
          track.classList.remove('is-dragging');
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        };
        track.addEventListener('pointerup', stopDragging);
        track.addEventListener('pointercancel', stopDragging);
        track.addEventListener('click', (event) => {
          if (!dragMoved) return;
          event.preventDefault();
          event.stopPropagation();
          dragMoved = false;
        }, true);
        track.addEventListener('scroll', updateArrows, { passive: true });
        const observer = new ResizeObserver(() => {
          updateArrows();
          this.updateSidebarHeight();
        });
        observer.observe(track);
        requestAnimationFrame(updateArrows);
      }
      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          const selected = panel.id === selectedTab.getAttribute('aria-controls');
          panel.hidden = !selected;
          if (selected) {
            const productTrack = panel.querySelector('[data-brand-product-track]');
            if (productTrack) {
              const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
              productTrack.scrollTo({ left: 0, behavior });
            }
          }
        });
        requestAnimationFrame(this.updateSidebarHeight);
        if (this.brandTabs) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          const tabTop = selectedTab.offsetTop;
          const tabBottom = tabTop + selectedTab.offsetHeight;
          const viewTop = this.brandTabs.scrollTop;
          const viewBottom = viewTop + this.brandTabs.clientHeight;
          if (tabTop < viewTop) {
            this.brandTabs.scrollTo({ top: tabTop, behavior });
          } else if (tabBottom > viewBottom) {
            this.brandTabs.scrollTo({ top: tabBottom - this.brandTabs.clientHeight, behavior });
          }
        }
        if (this.scrollTrack) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          const left = selectedTab.offsetLeft - (this.scrollTrack.clientWidth - selectedTab.offsetWidth) / 2;
          this.scrollTrack.scrollTo({ left: Math.max(0, left), behavior });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weroll-home-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ride-finder')) {
    class RideFinder extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.form = this.querySelector('[data-finder-form]');
        this.budgetMin = this.querySelector('[data-budget-min]');
        this.budgetMax = this.querySelector('[data-budget-max]');
        this.budgetTrack = this.querySelector('[data-budget-track]');
        if (!this.form || !this.budgetMin || !this.budgetMax || !this.budgetTrack) return;
        this.dataset.ready = 'true';
        this.eventController = new AbortController();
        const listenerOptions = { signal: this.eventController.signal };
        this.products = this.readProducts();
        this.numberFormatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { maximumFractionDigits: 0 });
        this.restoreFromUrl();
        this.form.addEventListener('input', (event) => {
          if (event.target === this.budgetMin || event.target === this.budgetMax) this.constrainBudget(event.target);
          this.update();
        }, listenerOptions);
        this.form.addEventListener('submit', (event) => this.submit(event), listenerOptions);
        this.querySelector('[data-clear-filters]')?.addEventListener('click', () => this.clear(), listenerOptions);
        this.querySelectorAll('[data-clear-filter]').forEach((button) => button.addEventListener('click', () => this.clearFilter(button.dataset.clearFilter), listenerOptions));
        window.addEventListener('pageshow', () => {
          // History navigation can restore form values after pageshow has fired.
          window.clearTimeout(this.restoreTimer);
          this.restoreTimer = window.setTimeout(() => {
            this.constrainBudget();
            this.update();
          }, 0);
        }, listenerOptions);
        this.update();
      }
      disconnectedCallback() {
        this.eventController?.abort();
        window.clearTimeout(this.restoreTimer);
        delete this.dataset.ready;
      }
      readProducts() {
        try { return JSON.parse(this.querySelector('[data-finder-products]')?.textContent || '[]'); }
        catch (error) { return []; }
      }
      selectedInput(name) {
        return Array.from(this.form.querySelectorAll('input[type="radio"]')).find((input) => input.name === name && input.checked);
      }
      selectedValue(name) { return this.selectedInput(name)?.value || ''; }
      selectedLabel(name) {
        const input = this.selectedInput(name);
        return input?.dataset.label || input?.nextElementSibling?.textContent.trim() || '';
      }
      normalize(value) { return String(value ?? '').trim().toLocaleLowerCase(); }
      restoreRadio(name, value) {
        if (!value) return;
        const input = Array.from(this.form.querySelectorAll('input[type="radio"]')).find((item) => item.name === name && item.value === value);
        if (input) input.checked = true;
      }
      restoreFromUrl() {
        const params = new URLSearchParams(window.location.search);
        this.restoreRadio('filter.p.vendor', params.get('filter.p.vendor'));
        this.restoreRadio('filter.p.tag', params.get('filter.p.tag'));
        const minValue = params.get('filter.v.price.gte');
        const maxValue = params.get('filter.v.price.lte');
        const minParam = Number(minValue);
        const maxParam = Number(maxValue);
        if (minValue !== null && Number.isFinite(minParam)) this.budgetMin.value = String(Math.max(Number(this.budgetMin.min), Math.min(minParam, Number(this.budgetMin.max))));
        if (maxValue !== null && Number.isFinite(maxParam)) this.budgetMax.value = String(Math.max(Number(this.budgetMax.min), Math.min(maxParam, Number(this.budgetMax.max))));
        this.constrainBudget();
      }
      constrainBudget(changedInput) {
        const floor = Number(this.budgetMin.min);
        const ceiling = Number(this.budgetMax.max);
        const step = Number(this.budgetMin.step);
        let minBudget = Number(this.budgetMin.value);
        let maxBudget = Number(this.budgetMax.value);
        if (maxBudget - minBudget < step) {
          if (changedInput === this.budgetMax) maxBudget = Math.min(ceiling, minBudget + step);
          else minBudget = Math.max(floor, maxBudget - step);
        }
        this.budgetMin.value = String(minBudget);
        this.budgetMax.value = String(maxBudget);
      }
      update() {
        const brand = this.normalize(this.selectedValue('filter.p.vendor'));
        const useCase = this.normalize(this.selectedValue('filter.p.tag'));
        const minBudget = Number(this.budgetMin.value);
        const maxBudget = Number(this.budgetMax.value);
        const floorBudget = Number(this.budgetMin.min);
        const ceilingBudget = Number(this.dataset.maxBudget);
        const matches = this.products.filter((product) => {
          const vendorMatches = !brand || this.normalize(product?.vendor) === brand;
          const tags = Array.isArray(product?.tags) ? product.tags.map((tag) => this.normalize(tag)) : [];
          const prices = Array.isArray(product?.prices) ? product.prices : [];
          const priceMatches = prices.some((value) => {
            const price = Number(value);
            return Number.isFinite(price) && price >= minBudget * 100 && (maxBudget >= ceilingBudget || price <= maxBudget * 100);
          });
          return vendorMatches && (!useCase || tags.includes(useCase)) && priceMatches;
        }).length;
        const budgetScale = ceilingBudget - floorBudget;
        this.budgetTrack.style.setProperty('--budget-start', (budgetScale > 0 ? ((minBudget - floorBudget) / budgetScale) * 100 : 0) + '%');
        this.budgetTrack.style.setProperty('--budget-end', (budgetScale > 0 ? ((maxBudget - floorBudget) / budgetScale) * 100 : 100) + '%');
        const budgetRange = this.numberFormatter.format(minBudget) + ' € – ' + this.numberFormatter.format(maxBudget) + ' €' + (maxBudget >= ceilingBudget ? '+' : '');
        const budgetText = minBudget <= floorBudget && maxBudget >= ceilingBudget ? this.dataset.anyBudget + ' (' + budgetRange + ')' : budgetRange;
        const brandStatus = this.querySelector('[data-brand-status]');
        const useCaseStatus = this.querySelector('[data-use-case-status]');
        const budgetStatus = this.querySelector('[data-budget-status]');
        if (brandStatus) brandStatus.textContent = this.selectedLabel('filter.p.vendor');
        if (useCaseStatus) useCaseStatus.textContent = this.selectedLabel('filter.p.tag');
        if (budgetStatus) budgetStatus.textContent = budgetText;
        this.budgetMin.setAttribute('aria-valuetext', this.numberFormatter.format(minBudget) + ' €');
        this.budgetMax.setAttribute('aria-valuetext', this.numberFormatter.format(maxBudget) + ' €' + (maxBudget >= ceilingBudget ? '+' : ''));
        const hasFilters = Boolean(brand || useCase || minBudget > floorBudget || maxBudget < ceilingBudget);
        const count = hasFilters ? matches : Number(this.dataset.initialCount);
        this.querySelectorAll('[data-match-count], [data-footer-count]').forEach((element) => { element.textContent = this.numberFormatter.format(count); });
        this.querySelector('[data-empty-state]').hidden = count !== 0;
      }
      filterValues() {
        const values = new Map();
        values.set('filter.p.vendor', this.selectedValue('filter.p.vendor'));
        values.set('filter.p.tag', this.selectedValue('filter.p.tag'));
        values.set('filter.v.price.gte', Number(this.budgetMin.value) > Number(this.budgetMin.min) ? this.budgetMin.value : '');
        values.set('filter.v.price.lte', Number(this.budgetMax.value) < Number(this.dataset.maxBudget) ? this.budgetMax.value : '');
        return values;
      }
      clearFilter(name) {
        if (name === 'budget') {
          this.budgetMin.value = this.budgetMin.min;
          this.budgetMax.value = this.dataset.maxBudget;
        } else {
          const emptyOption = Array.from(this.form.querySelectorAll('input[type="radio"]')).find((input) => input.name === name && input.value === '');
          if (emptyOption) emptyOption.checked = true;
        }
        this.update();
      }
      clear() {
        this.form.reset();
        this.budgetMin.value = this.budgetMin.min;
        this.budgetMax.value = this.dataset.maxBudget;
        this.update();
        this.form.querySelector('input[type="radio"]')?.focus();
      }
      submit(event) {
        event.preventDefault();
        const action = this.form.getAttribute('action') || this.form.action;
        const normalizedAction = action.startsWith('shopify://') ? action.replace(/^shopify:\/\//, '/') : action;
        const url = new URL(normalizedAction, window.location.origin);
        this.filterValues().forEach((value, name) => {
          url.searchParams.delete(name);
          if (value) url.searchParams.set(name, value);
        });
        window.location.assign(url.toString());
      }
    }
    customElements.define('ride-finder', RideFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weroll-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weroll-hero-slider')) {
    customElements.define('weroll-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-slider-dot]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplay = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.desktopViewport = window.matchMedia('(min-width: 990px)');
        this.style.setProperty('--wr-hero-interval', `${this.interval}ms`);
        this.querySelector('[data-slider-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.sliderDot), true)));
        this.pauseButton = this.querySelector('[data-slider-pause]');
        this.pauseButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
          if (event.key === 'ArrowRight') this.show(this.index + 1, true);
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => { if (this.autoplay && !this.classList.contains('is-paused')) this.start(); });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget) && this.autoplay && !this.classList.contains('is-paused')) this.start(); });
        this.addEventListener('touchstart', (event) => { this.touchStart = event.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStart;
          if (Math.abs(distance) > 50) this.show(this.index + (distance < 0 ? 1 : -1), true);
        }, { passive: true });
        document.addEventListener('visibilitychange', this.visibilityHandler = () => document.hidden ? this.stop() : this.start());
        document.addEventListener('shopify:block:select', this.blockSelectHandler = (event) => {
          const slide = event.target.closest('[data-slide]');
          if (!slide || !this.contains(slide)) return;
          this.show(this.slides.indexOf(slide));
          this.stop();
        });
        window.addEventListener('resize', this.resizeHandler = () => this.scheduleHeightSync(), { passive: true });
        window.visualViewport?.addEventListener('resize', this.resizeHandler, { passive: true });
        this.desktopViewport.addEventListener?.('change', this.resizeHandler);
        document.addEventListener('shopify:section:load', this.sectionLoadHandler = () => {
          this.observeHeightDependencies();
          this.scheduleHeightSync();
        });
        this.observeHeightDependencies();
        this.scheduleHeightSync();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.domReadyHandler = () => {
            this.observeHeightDependencies();
            this.scheduleHeightSync();
          }, { once: true });
        }
        this.syncVideos();
        if (this.autoplay && this.slides.length > 1) this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        document.removeEventListener('shopify:block:select', this.blockSelectHandler);
        document.removeEventListener('shopify:section:load', this.sectionLoadHandler);
        document.removeEventListener('DOMContentLoaded', this.domReadyHandler);
        window.removeEventListener('resize', this.resizeHandler);
        window.visualViewport?.removeEventListener('resize', this.resizeHandler);
        this.desktopViewport?.removeEventListener?.('change', this.resizeHandler);
        this.heightObserver?.disconnect();
        window.cancelAnimationFrame(this.heightFrame);
      }

      observeHeightDependencies() {
        if (typeof ResizeObserver === 'undefined') return;
        this.heightObserver?.disconnect();
        this.heightObserver = new ResizeObserver(() => this.scheduleHeightSync());
        document.querySelectorAll('.shopify-section-group-header-group').forEach((section) => this.heightObserver.observe(section));
        const advantages = this.getAdvantagesSection();
        if (advantages) this.heightObserver.observe(advantages);
      }

      getAdvantagesSection() {
        const heroSection = this.closest('.shopify-section');
        const nextSection = heroSection?.nextElementSibling;
        return nextSection?.querySelector('.wr-advantages')?.closest('.shopify-section')
          || document.querySelector('.wr-advantages')?.closest('.shopify-section');
      }

      scheduleHeightSync() {
        window.cancelAnimationFrame(this.heightFrame);
        this.heightFrame = window.requestAnimationFrame(() => this.syncHeight());
      }

      syncHeight() {
        if (!this.desktopViewport.matches) {
          this.style.removeProperty('--wr-hero-desktop-height');
          const heroTop = this.getBoundingClientRect().top + window.scrollY;
          const viewportHeight = window.visualViewport?.height || document.documentElement.clientHeight;
          const heroHeight = Math.max(0, viewportHeight - heroTop);
          this.style.setProperty('--wr-hero-mobile-viewport-height', Math.round(heroHeight) + 'px');
          return;
        }

        this.style.removeProperty('--wr-hero-mobile-viewport-height');
        const advantages = this.getAdvantagesSection();
        if (!advantages) return;

        const advantagesStyles = window.getComputedStyle(advantages);
        const advantagesHeight = advantages.getBoundingClientRect().height
          + (parseFloat(advantagesStyles.marginTop) || 0);
        const heroTop = this.getBoundingClientRect().top + window.scrollY;
        const viewportHeight = document.documentElement.clientHeight;
        const heroHeight = Math.max(0, viewportHeight - heroTop - advantagesHeight);
        this.style.setProperty('--wr-hero-desktop-height', Math.round(heroHeight) + 'px');
      }

      show(nextIndex, restart = false) {
        if (this.slides.length < 2) return;
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          active ? slide.removeAttribute('inert') : slide.setAttribute('inert', '');
        });
        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        this.syncVideos();
        if (restart && this.autoplay && !this.classList.contains('is-paused')) this.start();
      }

      syncVideos() {
        this.slides.forEach((slide, index) => slide.querySelectorAll('video').forEach((video) => {
          if (index === this.index && video.offsetParent !== null) video.play().catch(() => {});
          else video.pause();
        }));
      }

      start() {
        if (!this.autoplay || document.hidden || this.slides.length < 2) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stop() { window.clearInterval(this.timer); }

      toggleAutoplay() {
        const paused = this.classList.toggle('is-paused');
        this.pauseButton.setAttribute('aria-label', paused ? 'Diashow abspielen' : 'Diashow pausieren');
        paused ? this.stop() : this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weroll-home-parts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wr-parts-tabs')) {
    customElements.define('wr-parts-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-parts-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-parts-panel]'));
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-parts-tab]');
          if (tab && this.contains(tab)) this.selectTab(tab);
        });
        this.addEventListener('keydown', (event) => {
          const currentIndex = this.tabs.indexOf(event.target);
          if (currentIndex < 0) return;
          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex !== currentIndex) {
            event.preventDefault();
            this.selectTab(this.tabs[nextIndex]);
            this.tabs[nextIndex].focus();
          }
        });
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[data-parts-tab]');
          if (tab) this.selectTab(tab);
        });
      }
      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === selectedTab;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== selectedTab.getAttribute('aria-controls');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
